import { createAsyncPatcher } from "./patcher";
import { defaultHtmlFactory, defaultHtmlInitRules, defaultLayout } from "./Html";
import { mixin } from "./mix";
import { pipe } from "./pipe";
import { callable } from "./value";
export const mix = (...args) => {
    return mixin.apply(this, args);
};
// export const mix2 = <T, X>(a: HtmlBlueprint<T>, b?: HtmlBlueprint<X>) : Mixed<HtmlBlueprint<T&X>> => {
//     return mixin(b as any, a as any) as Mixed<HtmlBlueprint<T&X>>
// }
export const buildHtmlOptions = (blueprint) => {
    const b = mixin(blueprint).build(defaultHtmlInitRules);
    if (typeof b === 'boolean') {
        return null;
    }
    return b;
};
export const buildHtmlContext = (renderer, patcher) => {
    const p = patcher || createAsyncPatcher();
    return {
        $defaultFactory: defaultHtmlFactory,
        $defaultLayout: defaultLayout,
        $patcher: p,
        $renderer: renderer,
        $pipe: pipe(p, renderer)
    };
};
export const attach = (html, el) => {
    if (document.readyState == 'complete') {
        html.attach(el());
    }
    else {
        document.addEventListener('DOMContentLoaded', () => {
            html.attach(el());
        });
    }
};
export const detach = (html) => {
    html.detach();
};
export const watch = (f, objects) => {
    for (let obj of objects) {
        if (obj == null) {
            throw Error('Watched object is null');
        }
        obj.$subscribe(() => f.apply(this, [objects.map(o => o.$value)]));
        //        (obj as Observable<unknown>).$subscribe(() => autoTerminalAware(f))
    }
};
export const dispatchable = callable;
